import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import PropTypes from '../../types';
import { selectors } from '../../infrastructure/config';
import PersonalInformationPage from './PersonalInformationPage';
import { dataCaptureSelectors, savePersonalInformationForm } from '../../store/dataCapture';
import {
  ROUTE_INITIAL_QUESTION_PAGE,
  PERSONAL_INFO,
  WEB_REF_FAIR_PROCESSING,
  LINK_CODE_KEY
} from '../../utils/constants';

class PersonalInformationSection extends Component {
  constructor(props) {
    super(props);
    this.state = { isTermsChecked: false };
    this.businessBack = this.businessBack.bind(this);
    this.onConfirmationCheckboxChange = this.onConfirmationCheckboxChange.bind(this);
  }

  businessBack() {
    this.props.history.push(ROUTE_INITIAL_QUESTION_PAGE);
  }

  onConfirmationCheckboxChange({ isChecked }) {
    this.setState({ isTermsChecked: isChecked });
  }

  render() {
    const { bankId, savePersonalInformationForm, getBusinessData, pdfRef } = this.props;

    return (
      <PersonalInformationPage
        bankId={bankId}
        savePersonalInformationForm={() => {
          this.state.isTermsChecked && savePersonalInformationForm();
        }}
        getBusinessData={getBusinessData}
        pdfRef={pdfRef}
        isTermsChecked={this.state.isTermsChecked}
        onConfirmationCheckboxChange={this.onConfirmationCheckboxChange}
      />
    );
  }
}

PersonalInformationSection.propTypes = {
  brandId: PropTypes.brandId,
  bankId: PropTypes.bankId,
  savePersonalInformationForm: PropTypes.func.isRequired
};

const actionCreators = {
  savePersonalInformationForm
};

const mapStateToProps = state => ({
  brandId: selectors.brandId(state),
  bankId: selectors.bankId(state),
  accessToken: selectors.accessToken(state),
  linkCode: selectors.getSingleEntry(state, LINK_CODE_KEY),
  getBusinessData: dataCaptureSelectors.getBusinessData(state, PERSONAL_INFO),
  pdfRef: selectors.getPdfByWebReference(state, WEB_REF_FAIR_PROCESSING)
});

const mapDispatchToProps = dispatch => bindActionCreators(actionCreators, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(PersonalInformationSection);
